import React, { useState, useEffect } from 'react'
import { Box, TextInput, SimpleGrid, Flex, Group, Button, Select, NumberInput, Textarea, Text, Avatar, Loader } from '@mantine/core'
import { quantityUnit } from '../../../helper/master-unit'
import { validation } from '../../../plugins/validation'
import { getAllCurrencyList } from '../../../services/currency'
import { getListUsers } from '../../../services/users'
import LoadingData from '../../ui/LoadingData'
import { IconCheck } from '@tabler/icons-react'
import { addSourcingRequest, updateSourcingRequest } from '../../../services/sourcing-request'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import { useDebouncedCallback } from '@mantine/hooks'

const defaultVal = {
  request_number: '',
  title: '',
  brand: '',
  quantity: 0,
  quantity_unit: 'pcs',
  currency: 'IDR',
  price: 0,
  user_id: null,
  agent_id: null,
  sales_by: null,
  product_seeker_id: null,
  description: '',
}

const formValidation = {
  request_number: {
    isError: false,
    message: ''
  },
  title: {
    isError: false,
    message: ''
  },
  brand: {
    isError: false,
    message: ''
  },
  quantity: {
    isError: false,
    message: ''
  },
  quantity_unit: {
    isError: false,
    message: ''
  },
  currency: {
    isError: false,
    message: ''
  },
  price: {
    isError: false,
    message: ''
  },
  user_id: {
    isError: false,
    message: ''
  },
  description: {
    isError: false,
    message: ''
  },
}

const FormProductRequest = ({ dataSourcingRequest, onCloseModal, reloadList }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [currencyList, setCurrencyList] = useState([])
  const [userList, setUserList] = useState([])
  const [agentList, setAgentList] = useState([])
  const [salesList, setSalesList] = useState([])
  const [seekerList, setSeekerList] = useState([])
  const [loadingData, setLoadingData] = useState(true)
  const [loadingUser, setLoadingUser] = useState(true)
  const [loadingAgent, setLoadingAgent] = useState(true)
  const [loadingSales, setLoadingSales] = useState(true)
  const [loadingSeeker, setLoadingSeeker] = useState(true)
  const [searchUser, setSearchUser] = useState('')
  const [searchAgent, setSearchAgent] = useState('')
  const [searchSales, setSearchSales] = useState('')
  const [searchSeeker, setSearchSeeker] = useState('')

  const submitSourcingRequest = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''
    let payload = {}
    let validateForm = {}
    if (dataSourcingRequest === null) {
      validateForm = {
        title: form.title,
        brand: form.brand,
        quantity: form.quantity.toString(),
        quantity_unit: form.quantity_unit,
        currency: form.currency,
        price: form.price.toString(),
        user_id: form.user_id,
        description: form.description
      }
      delete validationForm.request_number
    } else {
      validateForm = {
        request_number: form.request_number,
        title: form.title,
        brand: form.brand,
        quantity: form.quantity.toString(),
        quantity_unit: form.quantity_unit,
        currency: form.currency,
        price: form.price.toString(),
        user_id: form.user_id,
        description: form.description
      }
    }
    
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    if (dataSourcingRequest === null) {
      payload = {
        title: form.title,
        brand: form.brand,
        quantity: form.quantity,
        quantity_unit: form.quantity_unit,
        currency: form.currency,
        price: form.price,
        user_id: form.user_id !== null ? Number(form.user_id) : null,
        agent_id: form.agent_id !== null ? Number(form.agent_id) : null,
        description: form.description,
        sales_by: form.sales_by !== null ? Number(form.sales_by) : null,
        product_seeker_id: form.product_seeker_id !== null ? Number(form.product_seeker_id) : null
      }
      methodFunction = addSourcingRequest(payload)
      titleMessageSuccess = 'Add Sourcing Request Successfully'
      captionMessageSuccess = 'You have been added new sourcing request'
      titleMessageError = 'Add Sourcing Request Error'
    } else {
      payload = {
        request_number: form.request_number,
        title: form.title,
        brand: form.brand,
        quantity: form.quantity,
        quantity_unit: form.quantity_unit,
        currency: form.currency,
        price: form.price,
        user_id: form.user_id !== null ? Number(form.user_id) : null,
        agent_id: form.agent_id !== null ? Number(form.agent_id) : null,
        description: form.description,
        sales_by: form.sales_by !== null ? Number(form.sales_by) : null,
        product_seeker_id: form.product_seeker_id !== null ? Number(form.product_seeker_id) : null
      }
      methodFunction = updateSourcingRequest(form.id, payload)
      titleMessageSuccess = 'Update Sourcing Request Successfully'
      captionMessageSuccess = 'You have been updated data sourcing request'
      titleMessageError = 'Update Sourcing Request Error'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetCurrenciesList = async () => {
    setLoadingData(true)
    const params = {
      groupBy: 'currency_code'
    }
    try {
      const response = await getAllCurrencyList(params)
      const dataCurrencies = response.data
      const remapCurrency = dataCurrencies.map((val) => {
        return val.attributes.currency_code
      })
      setCurrencyList(remapCurrency)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingData(false)
    }
  }

  const handleGetListUsers = useDebouncedCallback(async (userId) => {
    setLoadingUser(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchUser,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setUserList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUser(false)
    }
  }, 300)

  const handleGetListAgent = useDebouncedCallback(async (userId) => {
    setLoadingAgent(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchAgent,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true,
      'filter[is_agent][is]': 1,

    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setAgentList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingAgent(false)
    }
  }, 300)

  const handleGetListSales = useDebouncedCallback(async (userId) => {
    setLoadingSales(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchSales,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setSalesList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSales(false)
    }
  }, 300)

  const handleGetListSeeker = useDebouncedCallback(async (userId) => {
    setLoadingSeeker(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchSeeker,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setSeekerList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSeeker(false)
    }
  }, 300)

  useEffect(() => {
    handleGetListUsers()
    // eslint-disable-next-line
  }, [searchUser])

  useEffect(() => {
    handleGetListAgent()
    // eslint-disable-next-line
  }, [searchAgent])

  useEffect(() => {
    handleGetListSales()
    // eslint-disable-next-line
  }, [searchSales])

  useEffect(() => {
    handleGetListSeeker()
    // eslint-disable-next-line
  }, [searchSeeker])

  useEffect(() => {
    handleGetCurrenciesList()
    if (dataSourcingRequest) {
      if (dataSourcingRequest.user !== null) {
        handleGetListUsers(dataSourcingRequest.user.id)
      }
      if (dataSourcingRequest.agent !== null) {
        handleGetListAgent(dataSourcingRequest.agent.id)
      }
      if (dataSourcingRequest.sales_by !== null) {
        handleGetListSales(dataSourcingRequest.sales_by)
      }
      if (dataSourcingRequest.product_seeker !== null) {
        handleGetListSeeker(dataSourcingRequest.product_seeker.id)
      }
      handleSetForm(dataSourcingRequest)
    }
    // eslint-disable-next-line
  }, [dataSourcingRequest])

  const handleSetForm = (value) => {
    const dataDetail = {
      id: value.id,
      request_number: value.request_number,
      title: value.title,
      brand: value.brand,
      quantity_unit: value.quantity_unit.toLowerCase(),
      quantity: value.quantity,
      currency: value.currency,
      price: value.price,
      description: value.description,
      user_id: value.user !== null ? value.user.id.toString() : null,
      agent_id: value.agent !== null ? value.agent.id.toString() : null,
      sales_by: value.sales_by !== null ? value.sales_by.toString() : null,
      product_seeker_id: value.product_seeker !== null ? value.product_seeker.id.toString() : null
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const mappingForm = (data) => {
    const showRequestNumber = (dataRequest) => {
      if (dataRequest !== null) {
        return (
          <Box mb='md'>
            <TextInput
              name='request_number'
              value={formData.request_number}
              label='RFQ Number'
              placeholder='Input RFQ Number'
              error={validationForm.request_number.isError ? `${validationForm.request_number.message}` : ''}
              onChange={(val) => handleChangeForm('request_number', val.target.value)}
              withAsterisk
              size='xs'
            />
          </Box>
        )
      }
    }

    const renderUserOption = ({ option, checked }) => {
      return (
        <Group flex="1" align='center' gap="xs">
          <Flex gap='sm' align='center'>
            <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
            <Box>
              <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
              <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
            </Box>
          </Flex>
          {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
        </Group>
      )
    }

    const loadingDataUser = () => {
      return (
        <Box ta='center' my={12}>
          <Loader size={16} />
          <Text c='gray.6' fz={11}>Loading Data</Text>
        </Box>
      )
    }

    return (
      <Box>
        {showRequestNumber(data)}
        <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
          <Box>
            <TextInput
              name='title'
              value={formData.title}
              label='Product Name'
              placeholder='Input Product Name'
              error={validationForm.title.isError ? `${validationForm.title.message}` : ''}
              onChange={(val) => handleChangeForm('title', val.target.value)}
              withAsterisk
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='brand'
              value={formData.brand}
              label='Brand'
              placeholder='Input Brand'
              error={validationForm.brand.isError ? `${validationForm.brand.message}` : ''}
              onChange={(val) => handleChangeForm('brand', val.target.value)}
              withAsterisk
              size='xs'
            />
          </Box>
          <Box>
            <Select
              name='quantity_unit'
              value={formData.quantity_unit}
              label='Quantity Unit'
              placeholder='Select quantity unit'
              data={quantityUnit}
              onChange={(val) => handleChangeForm('quantity_unit', val)}
              size='xs'
              error={validationForm.quantity_unit.isError ? `${validationForm.quantity_unit.message}` : ''}
              withAsterisk
            />
          </Box>
          <Box>
            <NumberInput
              name='quantity'
              label="Quantity"
              value={formData.quantity}
              rightSection={<Text fz='xs' c='black' tt='capitalize'>{formData.quantity_unit}</Text>}
              placeholder='Input quantity'
              onChange={(val) => handleChangeForm('quantity', val)}
              error={validationForm.quantity.isError ? `${validationForm.quantity.message}` : ''}
              size='xs'
              withAsterisk
              rightSectionWidth={40}
            />
          </Box>
          <Box>
            <Select
              name='currency'
              value={formData.currency}
              label='Currency'
              placeholder='Select currency'
              data={currencyList}
              onChange={(val) => handleChangeForm('currency', val)}
              size='xs'
              error={validationForm.currency.isError ? `${validationForm.currency.message}` : ''}
              withAsterisk
            />
          </Box>
          <Box>
            <NumberInput
              label={`Price / ${formData.quantity_unit}`}
              value={formData.price}
              leftSection={<Text fz={12} c='black' tt='capitalize'>{formData.currency}</Text>}
              onChange={(val) => handleChangeForm('price', val)}
              error={validationForm.price.isError ? `${validationForm.price.message}` : ''}
              thousandSeparator=","
              size='xs'
              leftSectionWidth={40}
              withAsterisk
            />
          </Box>
          <Box>
            <Select
              name='user_id'
              value={formData.user_id}
              label='Select User'
              data={userList}
              renderOption={renderUserOption}
              onChange={(val) => handleChangeForm('user_id', val)}
              error={validationForm.user_id.isError ? `${validationForm.user_id.message}` : ''}
              size='xs'
              searchable
              searchValue={searchUser}
              onSearchChange={setSearchUser}
              nothingFoundMessage={!loadingUser ? userList.length > 0 ? '' : 'No User Found' : loadingDataUser()}
              clearable
              withAsterisk
            />
          </Box>
          <Box>
            <Select
              name='agent_id'
              value={formData.agent_id}
              label='Select Agent'
              data={agentList}
              renderOption={renderUserOption}
              onChange={(val) => handleChangeForm('agent_id', val)}
              size='xs'
              searchable
              searchValue={searchAgent}
              onSearchChange={setSearchAgent}
              nothingFoundMessage={!loadingAgent ? agentList.length > 0 ? '' : 'No Agent Found' : loadingDataUser()}
              clearable
            />
          </Box>
          <Box>
            <Select
              name='sales_by'
              value={formData.sales_by}
              label='Select Sales'
              data={salesList}
              renderOption={renderUserOption}
              onChange={(val) => handleChangeForm('sales_by', val)}
              size='xs'
              searchable
              searchValue={searchSales}
              onSearchChange={setSearchSales}
              nothingFoundMessage={!loadingSales ? salesList.length > 0 ? '' : 'No Sales Found' : loadingDataUser()}
              clearable
            />
          </Box>
          <Box>
            <Select
              name='product_seeker_id'
              value={formData.product_seeker_id}
              label='Select Product Seeker'
              data={seekerList}
              renderOption={renderUserOption}
              onChange={(val) => handleChangeForm('product_seeker_id', val)}
              size='xs'
              searchable
              searchValue={searchSeeker}
              onSearchChange={setSearchSeeker}
              nothingFoundMessage={!loadingSeeker ? seekerList.length > 0 ? '' : 'No Product Seeker Found' : loadingDataUser()}
              clearable
            />
          </Box>
        </SimpleGrid>
        <Box>
          <Textarea
            name='description'
            label="Description"
            placeholder="Input description"
            value={formData.description}
            onChange={(val) => handleChangeForm('description', val.target.value)}
            error={validationForm.description.isError ? `${validationForm.description.message}` : ''}
            size='xs'
            autosize
            minRows={4}
            maxRows={4}
            withAsterisk
          />
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitSourcingRequest(formData)}>{dataSourcingRequest !== null ? 'Update' : 'Create'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingData ? <LoadingData /> : mappingForm(dataSourcingRequest)}
    </Box>
  )
}

export default FormProductRequest